import gql from 'graphql-tag';

export default gql`
  mutation AUTH_PASSWORD_RESET_EMAIL($email: String!, $originUrl: String!) {
    authSendPasswordResetEmail(email: $email, originUrl: $originUrl)
  }
`
